export default "__VITE_ASSET__DyJPhoHc__"